<template>
  <ul class="social">
    <li
      class="social__item"
      v-for="(socialBtn, index) in socialBtns"
      :key="index"
    >
      <BaseSocialLink
        class="social__btn"
        :href="socialBtn.href"
        :customClass="socialBtn.type"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialList',
  props: {
    socialBtns: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.social {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  &__item {
    &:not(:last-of-type) {
      margin-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/SocialList.vue